interface ChevronProps {
  direction: 'up' | 'down' | 'left' | 'right'
}

export const Chevron = ({ direction }: ChevronProps) => {
  const rotationMap: Record<ChevronProps['direction'], string> = {
    up: 'rotate(180deg)',
    down: 'rotate(0deg)',
    left: 'rotate(90deg)',
    right: 'rotate(-90deg)',
  }

  return (
    <span
      style={{
        display: 'inline-block',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%235C6F8A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9" /></svg>')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '16px',
        width: '16px',
        height: '16px',
        transform: rotationMap[direction],
        transition: 'transform 0.2s',
      }}
    />
  )
}
